import { Injectable } from '@angular/core'

import { Observable, combineLatest, firstValueFrom } from 'rxjs'
import { map } from 'rxjs/operators'

import { AsiakasService } from './asiakas/asiakas.service'
import { KirjanpitajaService } from './kirjanpitaja/kirjanpitaja.service'
import { KirjautunutKayttajaService } from './kirjautunut-kayttaja.service'

import { lemonShare } from '../../_jaettu-angular/_rxjs/lemon-share.operator'
import { LemonatorNakyma } from '../../_jaettu-lemonator/model/lemonator-nakyma'

export type LemonatorNakymaRyhma = 'Kirjanpito' | 'Lemonaid' | 'Asetukset' | 'Asiakaskohtainen ylläpito' | 'Ylläpito' | 'Koti'

export type LemonatorAlavalikko = 'kirjanpito' | 'lemonaid' | 'asetukset' | 'yllapito'

export interface LemonatorNakymaTieto {
  avain: LemonatorNakyma
  nimi: string
  ryhma: LemonatorNakymaRyhma
  reitti: string[]
}

export const LEMONATOR_NAKYMAT: LemonatorNakymaTieto[] = [
  { avain: LemonatorNakyma.KIRJANPITO, nimi: 'Kirjanpito', ryhma: 'Kirjanpito', reitti: ['kirjanpito'] },

  { avain: LemonatorNakyma.TOSITTEET_LATAA, nimi: 'Lataa tositteita', ryhma: 'Lemonaid', reitti: ['tositteet', 'lataa'] },
  { avain: LemonatorNakyma.TOSITTEET_SELAA, nimi: 'Selaa tositteita', ryhma: 'Lemonaid', reitti: ['tositteet', 'selaa'] },
  { avain: LemonatorNakyma.LASKUT_SELAA, nimi: 'Selaa laskuja', ryhma: 'Lemonaid', reitti: ['laskut', 'selaa'] },
  { avain: LemonatorNakyma.LASKU_ASIAKKAAT_SELAA, nimi: 'Selaa asiakkaita', ryhma: 'Lemonaid', reitti: ['lasku-asiakkaat', 'selaa'] },
  { avain: LemonatorNakyma.TUOTTEET_SELAA, nimi: 'Selaa tuotteita', ryhma: 'Lemonaid', reitti: ['tuotteet', 'selaa'] },
  { avain: LemonatorNakyma.OSTOLASKUT_SELAA, nimi: 'Selaa ostolaskuja', ryhma: 'Lemonaid', reitti: ['ostolaskut', 'selaa'] },
  { avain: LemonatorNakyma.TOIMITTAJAT_SELAA, nimi: 'Selaa toimittajia', ryhma: 'Lemonaid', reitti: ['toimittajat', 'selaa'] },
  { avain: LemonatorNakyma.LASKUT_TOISTUVAT, nimi: 'Selaa toistuvia', ryhma: 'Lemonaid', reitti: ['laskut', 'toistuvat'] },
  { avain: LemonatorNakyma.KAYTTAJAT, nimi: 'Käyttäjät', ryhma: 'Lemonaid', reitti: ['kayttajat'] },
  { avain: LemonatorNakyma.MAKSUTAVAT, nimi: 'Maksutavat', ryhma: 'Lemonaid', reitti: ['maksutavat'] },
  { avain: LemonatorNakyma.AINEISTON_LATAUS, nimi: 'Aineiston lähetys', ryhma: 'Lemonaid', reitti: ['aineiston-lataus'] },
  { avain: LemonatorNakyma.KIRJANPIDON_ULKOPUOLISET_VAHENNYKSET, nimi: 'Kirjanpidon ulkopuoliset vähennykset', ryhma: 'Lemonaid', reitti: ['kirjanpidon-ulkopuoliset-vahennykset'] },
  { avain: LemonatorNakyma.LASKUASETUKSET, nimi: 'Laskuasetukset', ryhma: 'Lemonaid', reitti: ['laskuasetukset'] },

  { avain: LemonatorNakyma.ASIAKASTIEDOT, nimi: 'Asiakastiedot', ryhma: 'Asetukset', reitti: ['asiakastiedot'] },
  { avain: LemonatorNakyma.TUNTEMISTIEDOT, nimi: 'Tuntemistiedot', ryhma: 'Asetukset', reitti: ['tuntemistiedot'] },
  { avain: LemonatorNakyma.KIRJANPITOTIEDOT, nimi: 'Kirjanpito', ryhma: 'Asetukset', reitti: ['kirjanpitotiedot'] },
  { avain: LemonatorNakyma.SISAINEN_ARKISTO, nimi: 'Sisäinen arkisto', ryhma: 'Asetukset', reitti: ['sisainen-arkisto'] },
  { avain: LemonatorNakyma.LASKUTUS, nimi: 'Laskutus', ryhma: 'Asetukset', reitti: ['laskutus'] },
  { avain: LemonatorNakyma.SOPIMUKSET, nimi: 'Sopimukset', ryhma: 'Asetukset', reitti: ['sopimukset'] },
  { avain: LemonatorNakyma.HOLVI_IMPORT, nimi: 'Holvi', ryhma: 'Asetukset', reitti: ['holvi-import'] },
  { avain: LemonatorNakyma.AJASTETUT_TYOT, nimi: 'Ajastetut työt', ryhma: 'Asetukset', reitti: ['ajastetut-tyot'] },
  { avain: LemonatorNakyma.LATAUS_TYOT, nimi: 'Keskeneräiset työt', ryhma: 'Asetukset', reitti: ['lataus-tyot'] },
  { avain: LemonatorNakyma.TUONNIT, nimi: 'Tuonnit', ryhma: 'Asetukset', reitti: ['tuonnit'] },
  // Vanhat erilliset import-oikeudet jäävät hallintaan koska osa kirjanpitäjistä on saanut ne myönnettynä ennen TUONNIT-yhdistämistä.
  // Reitit johtavat samaan TuonnitComponentiin, joten oikeudet toimivat edelleen tarkoituksensa mukaisesti.
  { avain: LemonatorNakyma.ALKUSALDO_IMPORT, nimi: 'Alkusaldo import (vanha)', ryhma: 'Asetukset', reitti: ['alkusaldo-import'] },
  { avain: LemonatorNakyma.TUOTE_IMPORT, nimi: 'Tuote-import (vanha)', ryhma: 'Asetukset', reitti: ['tuote-import'] },

  { avain: LemonatorNakyma.PANKKIYHTEYDET, nimi: 'Pankkiyhteydet', ryhma: 'Asiakaskohtainen ylläpito', reitti: ['pankkiyhteydet'] },
  { avain: LemonatorNakyma.TILITAPAHTUMAT, nimi: 'Tilitapahtumat', ryhma: 'Asiakaskohtainen ylläpito', reitti: ['tilitapahtumat'] },
  { avain: LemonatorNakyma.PAIVASALDOT, nimi: 'Päiväsaldot', ryhma: 'Asiakaskohtainen ylläpito', reitti: ['paivasaldot'] },
  { avain: LemonatorNakyma.RESKONTRA_DEBUG, nimi: 'Reskontra-debug', ryhma: 'Asiakaskohtainen ylläpito', reitti: ['tilitapahtumat', 'kohdistusdebug'] },
  { avain: LemonatorNakyma.APIX_LASKUT, nimi: 'Apix laskut', ryhma: 'Asiakaskohtainen ylläpito', reitti: ['yllapito', 'apixlaskut'] },
  { avain: LemonatorNakyma.KIRJANPIDON_LAHETYKSET, nimi: 'Kirjanpidon lähetykset', ryhma: 'Asiakaskohtainen ylläpito', reitti: ['lahetykset'] },
  { avain: LemonatorNakyma.VERONMAKSU, nimi: 'Veron maksu', ryhma: 'Asiakaskohtainen ylläpito', reitti: ['veronmaksu'] },
  { avain: LemonatorNakyma.ALUSTA_KIRJANPITO, nimi: 'Alusta kirjanpito', ryhma: 'Asiakaskohtainen ylläpito', reitti: ['alusta-kirjanpito'] },
  { avain: LemonatorNakyma.YHTEISOMYYNTI_ILMOITUKSET, nimi: 'Yhteisömyynti-ilmoitukset', ryhma: 'Asiakaskohtainen ylläpito', reitti: ['yhteisomyynti-ilmoitukset'] },

  { avain: LemonatorNakyma.YLLAPITO_RAPORTIT, nimi: 'Raportit', ryhma: 'Ylläpito', reitti: ['yllapito', 'raportit'] },
  { avain: LemonatorNakyma.YLLAPITO_MASSAMUIKKARIT, nimi: 'Maksumuistutuksien massalähetys', ryhma: 'Ylläpito', reitti: ['yllapito', 'massamuikkarit'] },
  { avain: LemonatorNakyma.YLLAPITO_PAATILIKARTTA, nimi: 'Päätilikartta', ryhma: 'Ylläpito', reitti: ['yllapito', 'paatilikartta'] },
  { avain: LemonatorNakyma.YLLAPITO_LLM_TYOKALUT, nimi: 'LLM työkalut', ryhma: 'Ylläpito', reitti: ['yllapito', 'llm-tyokalut'] },
  { avain: LemonatorNakyma.YLLAPITO_LEMONAID_VIESTIT, nimi: 'Lemonaid-viestit', ryhma: 'Ylläpito', reitti: ['yllapito', 'lemonaid-viestit'] },
  { avain: LemonatorNakyma.YLLAPITO_INTEGRAATIOT_VEROHALLINTO, nimi: 'Integraatiot (Verohallinto)', ryhma: 'Ylläpito', reitti: ['yllapito', 'integraatiot-verohallinto'] },
  { avain: LemonatorNakyma.YLLAPITO_INTEGRAATIOT_HOLVI, nimi: 'Integraatiot (Holvi)', ryhma: 'Ylläpito', reitti: ['yllapito', 'integraatiot-holvi'] },
  { avain: LemonatorNakyma.YLLAPITO_KIRJANPITAJAT, nimi: 'Kirjanpitäjät', ryhma: 'Ylläpito', reitti: ['yllapito', 'kirjanpitajat'] },
  { avain: LemonatorNakyma.YLLAPITO_TIIMIT, nimi: 'Tiimit', ryhma: 'Ylläpito', reitti: ['yllapito', 'tiimit'] },
  { avain: LemonatorNakyma.YLLAPITO_TIIMIKOKONAISUUDET, nimi: 'Tiimikokonaisuudet', ryhma: 'Ylläpito', reitti: ['yllapito', 'tiimikokonaisuudet'] },
  { avain: LemonatorNakyma.YLLAPITO_TILINTARKASTAJAT, nimi: 'Tilintarkastajat', ryhma: 'Ylläpito', reitti: ['yllapito', 'tilintarkastajat'] },
  { avain: LemonatorNakyma.YLLAPITO_MONIYRITYSTUET, nimi: 'Moniyritystuet', ryhma: 'Ylläpito', reitti: ['yllapito', 'moniyritystuet'] },
  { avain: LemonatorNakyma.YLLAPITO_TAGIT, nimi: 'Tagit', ryhma: 'Ylläpito', reitti: ['yllapito', 'tagit'] },
  { avain: LemonatorNakyma.YLLAPITO_SOPIMUKSET, nimi: 'Sopimukset', ryhma: 'Ylläpito', reitti: ['yllapito', 'sopimukset'] },
  { avain: LemonatorNakyma.YLLAPITO_YHTEISOMYYNTILASKUT, nimi: 'Yhteisömyyntilaskut', ryhma: 'Ylläpito', reitti: ['yllapito', 'yhteisomyyntilaskut'] },
  { avain: LemonatorNakyma.YLLAPITO_PANKKIYHTEYDET, nimi: 'Pankkiyhteydet', ryhma: 'Ylläpito', reitti: ['yllapito', 'pankkiyhteydet'] },
  { avain: LemonatorNakyma.YLLAPITO_AJASTETUT_TYOT, nimi: 'Ajastetut työt', ryhma: 'Ylläpito', reitti: ['yllapito', 'ajastetut-tyot'] },
  { avain: LemonatorNakyma.YLLAPITO_LOGIT, nimi: 'Logit', ryhma: 'Ylläpito', reitti: ['yllapito', 'logit'] },
  { avain: LemonatorNakyma.YLLAPITO_SAHKOPOSTIPOHJAT, nimi: 'Sähköpostipohjat', ryhma: 'Ylläpito', reitti: ['yllapito', 'sahkopostipohjat'] },
  { avain: LemonatorNakyma.YLLAPITO_TILASTOJEN_SIIRTO, nimi: 'Laskutilastojen siirto', ryhma: 'Ylläpito', reitti: ['yllapito', 'tilastot', 'siirto'] },
  { avain: LemonatorNakyma.YLLAPITO_PUSH_ILMOITUKSET, nimi: 'Push-ilmoitukset asiakkaille', ryhma: 'Ylläpito', reitti: ['yllapito', 'push-ilmoitukset'] },

  { avain: LemonatorNakyma.ASIAKASHAKU, nimi: 'Asiakashaku', ryhma: 'Koti', reitti: ['haku'] },
  { avain: LemonatorNakyma.JAETTAVAT_ASIAKKAAT, nimi: 'Jaettavat asiakkaat', ryhma: 'Koti', reitti: ['jaettavat-asiakkaat'] },
]

const ALAVALIKKO_RYHMAT: Record<LemonatorAlavalikko, LemonatorNakymaRyhma> = {
  kirjanpito: 'Kirjanpito',
  lemonaid: 'Lemonaid',
  asetukset: 'Asetukset',
  yllapito: 'Asiakaskohtainen ylläpito',
}

export function kaikkiNakymatRecord(): Record<LemonatorNakyma, true> {
  const tulos = {} as Record<LemonatorNakyma, true>
  for (const nakyma of LEMONATOR_NAKYMAT) {
    tulos[nakyma.avain] = true
  }
  // Varmistetaan että kaikki LemonatorNakyma-enumin arvot löytyvät LEMONATOR_NAKYMAT-vakiosta
  const puuttuvat = Object.values(LemonatorNakyma).filter(arvo => !tulos[arvo])
  if (puuttuvat.length > 0) {
    throw new Error(`LEMONATOR_NAKYMAT-vakiosta puuttuu seuraavat LemonatorNakyma-arvot: ${puuttuvat.join(', ')}`)
  }
  return tulos
}

@Injectable()
export class NakymaOikeusService {
  sallitutNakymatObservable: Observable<Partial<Record<LemonatorNakyma, true>>>

  constructor(
    private _kirjanpitajaService: KirjanpitajaService,
    private _asiakasService: AsiakasService,
    private _kirjautunutKayttajaService: KirjautunutKayttajaService,
  ) {
    this.sallitutNakymatObservable = combineLatest([
      this._kirjanpitajaService.kirjautuneenKayttajanKirjanpitajaObservable,
      this._asiakasService.nykyinenAsiakasObservable,
      this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable,
    ]).pipe(
      map(([kirjanpitaja, asiakas, tiedot]) => {
        if (asiakas?.kasittelija === tiedot?.uid || asiakas?.kasittelijavara === tiedot?.uid) {
          return kaikkiNakymatRecord()
        }
        if (!kirjanpitaja?.allowedViews || Object.keys(kirjanpitaja.allowedViews).length === 0) {
          return kaikkiNakymatRecord()
        }
        return kirjanpitaja.allowedViews as Partial<Record<LemonatorNakyma, true>>
      }),
      lemonShare(),
    )
  }

  async annaEnsimmainenSallittuReittiRyhmalle(alavalikko: LemonatorAlavalikko): Promise<string[] | null> {
    const ryhmanNimi = ALAVALIKKO_RYHMAT[alavalikko]
    if (!ryhmanNimi) {
      return null
    }
    const sallitut = await firstValueFrom(this.sallitutNakymatObservable)
    const ryhmanNakymat = LEMONATOR_NAKYMAT.filter(n => n.ryhma === ryhmanNimi)
    const ensimmainenSallittu = ryhmanNakymat.find(n => sallitut[n.avain])
    return ensimmainenSallittu?.reitti ?? null
  }

  async annaEnsimmainenSallittuReitti(primaryIfAvailable: LemonatorNakyma): Promise<string[] | null> {
    const sallitut = await firstValueFrom(this.sallitutNakymatObservable)
    const primaryNakyma = LEMONATOR_NAKYMAT.find(n => n.avain === primaryIfAvailable)
    if (primaryNakyma) {
      // Palauta pyydetty reitti jos käyttäjällä on siihe oikeus
      if (sallitut[primaryIfAvailable]) {
        return primaryNakyma.reitti
      }

      // Palautetaan samasta ryhmästä ensimmäisenä löytyvä sallittu reitti
      const samanRyhmanNakymat = LEMONATOR_NAKYMAT.filter(n => n.ryhma === primaryNakyma.ryhma)
      const ensimmainenSallittuSamassaRyhmassa = samanRyhmanNakymat.find(n => sallitut[n.avain])
      if (ensimmainenSallittuSamassaRyhmassa) {
        return ensimmainenSallittuSamassaRyhmassa.reitti
      }
    }

    // Mikä tahansa reitti
    const ensimmainenSallittu = LEMONATOR_NAKYMAT.find(n => sallitut[n.avain])
    return ensimmainenSallittu?.reitti ?? null
  }
}
